import React, { useContext } from 'react';

/* packages */
import { Fetch } from '../../../lib-atomic-functions';
/* packages */

/* stores */
import Store from './store';
/* stores */

const index = ({CONFIG}) => {
  const orderSearchContext  = useContext(Store);
  const orderSearchMethod = async ({token, query}) => {
    orderSearchContext.setLoading({loading: true, status: false, data: false});
    CONFIG.application.order.api.headers.Authorization = token;
    const fetch = await Fetch({
      url: CONFIG.application.order.api.endpoints.list.url + query,
      config: {
        method: CONFIG.application.order.api.endpoints.list.method,
        headers: CONFIG.application.order.api.headers
      }
    });
    orderSearchContext.setLoading({loading: false, status: fetch[0], data: fetch[1]});
  }

  return { orderSearchContext, orderSearchMethod }
}

export default index;
